const choiceRegex = /<em>(.*?)<\/em>/g

const extractChoiceText = text =>
  (text || '').replace('/\n/g', ' ').match(choiceRegex)

export default extractChoiceText
